'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumEyeSlash = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.51975 2.29997C7.52682 2.29999 7.53351 2.30001 7.5398 2.30001H8.3398C8.36096 2.30001 8.38211 2.30097 8.40318 2.30289C8.47776 2.30967 8.52857 2.31001 8.64981 2.31001C8.67307 2.31001 8.69631 2.31117 8.71946 2.31349C8.80982 2.32252 8.89752 2.33129 8.99183 2.34001H9.05932C9.08834 2.34001 9.11783 2.34182 9.14663 2.34542C9.39937 2.37701 9.67397 2.42731 9.96889 2.4945C9.99636 2.49762 10.0236 2.50237 10.0506 2.50873C11.8447 2.93219 14.2949 4.20584 15.6623 7.72659C15.7381 7.92183 15.7215 8.13697 15.6244 8.3151C14.265 11.773 11.845 13.0226 10.0707 13.4564L10.0606 13.4593C10.042 13.4646 10.0168 13.4715 9.98533 13.4795C9.92238 13.4955 9.8341 13.5162 9.72208 13.5382C9.50736 13.5803 9.20506 13.6272 8.82649 13.6549C8.68727 13.6807 8.55955 13.6803 8.47986 13.6801C8.47279 13.68 8.46609 13.68 8.4598 13.68H8.26041C8.13542 13.6867 7.98147 13.6838 7.86261 13.6817C7.81451 13.6808 7.77216 13.68 7.7398 13.68H7.65998C7.63882 13.68 7.6175 13.6791 7.59643 13.6771C7.52185 13.6704 7.47104 13.67 7.3498 13.67C7.32654 13.67 7.3033 13.6689 7.28015 13.6665C7.17986 13.6565 7.08285 13.6468 6.97643 13.6371C6.95672 13.6353 6.93712 13.6327 6.91766 13.6293C6.89938 13.6284 6.88114 13.6269 6.86298 13.6246C6.61024 13.593 6.33564 13.5427 6.04071 13.4755C6.01324 13.4724 5.98596 13.4677 5.95901 13.4613C4.16489 13.0378 1.71468 11.7642 0.347289 8.24344C0.284209 8.08102 0.28397 7.90091 0.346617 7.73833C1.70052 4.22463 4.1421 2.96043 5.92893 2.5236L5.93901 2.52069C5.95765 2.51543 5.9828 2.50858 6.01428 2.50056C6.07723 2.48453 6.16551 2.46384 6.27753 2.44186C6.49225 2.39973 6.79456 2.35282 7.17312 2.32509C7.31235 2.29937 7.44006 2.29974 7.51975 2.29997ZM8.00019 5.29999C6.50878 5.29999 5.2998 6.50866 5.2998 7.99999C5.2998 9.49132 6.50878 10.7 8.00019 10.7C9.49101 10.7 10.6998 9.49114 10.6998 7.99999C10.6998 6.50883 9.49101 5.29999 8.00019 5.29999Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M2 2L14 14",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15 8C13.731 4.7278 11.488 3.59448 9.883 3.20781L9.884 3.2067C9.876 3.20448 9.869 3.20448 9.861 3.20226C9.566 3.13226 9.289 3.08448 9.048 3.0567V3.05448C9.015 3.05115 8.986 3.04893 8.953 3.0467C8.842 3.03559 8.74 3.0267 8.646 3.02115C8.53 3.01337 8.441 3.01448 8.336 3.01004C8.307 3.00893 8.281 3.00893 8.252 3.00781C8.068 3.00226 7.901 2.99781 7.754 3.00115C7.678 3.00226 7.608 3.00448 7.537 3.0067C7.431 3.01226 7.346 3.01559 7.27 3.02226C6.533 3.07559 6.114 3.2067 6.114 3.2067V3.20892C4.509 3.59559 2.268 4.72891 1 8C2.269 11.2722 4.512 12.4066 6.117 12.7922L6.116 12.7933C6.124 12.7955 6.131 12.7955 6.139 12.7977C6.434 12.8677 6.711 12.9155 6.952 12.9433V12.9455C6.985 12.9489 7.014 12.9511 7.047 12.9533C7.158 12.9644 7.26 12.9733 7.354 12.9789C7.47 12.9866 7.559 12.9855 7.664 12.99C7.693 12.9911 7.719 12.9911 7.748 12.9922C7.932 12.9977 8.099 13.0022 8.246 12.9989C8.322 12.9977 8.392 12.9955 8.463 12.9933C8.569 12.9877 8.654 12.9844 8.73 12.9777C9.467 12.9244 9.886 12.7933 9.886 12.7933V12.7911C11.491 12.4044 13.732 11.2711 15 8Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10 8C10 9.10462 9.10454 10 8.00039 10C6.89546 10 6 9.10462 6 8C6 6.89538 6.89546 6 8.00039 6C9.10454 6 10 6.89538 10 8Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M2 2L14 14",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        })
    });
};

module.exports = MediumEyeSlash;
